var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTune = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C8.448 16 8 15.552 8 15C8 14.448 8.448 14 9 14C9.552 14 10 14.448 10 15C10 15.552 9.552 16 9 16ZM19 14H11.815C11.401 12.839 10.302 12 9 12C7.698 12 6.599 12.839 6.185 14H1C0.447 14 0 14.447 0 15C0 15.553 0.447 16 1 16H6.185C6.599 17.161 7.698 18 9 18C10.302 18 11.401 17.161 11.815 16H19C19.553 16 20 15.553 20 15C20 14.447 19.553 14 19 14ZM17 10C16.448 10 16 9.552 16 9C16 8.448 16.448 8 17 8C17.552 8 18 8.448 18 9C18 9.552 17.552 10 17 10ZM17 6C15.698 6 14.599 6.839 14.185 8H1C0.447 8 0 8.447 0 9C0 9.553 0.447 10 1 10H14.185C14.599 11.161 15.698 12 17 12C18.654 12 20 10.654 20 9C20 7.346 18.654 6 17 6ZM5 2C5.552 2 6 2.448 6 3C6 3.552 5.552 4 5 4C4.448 4 4 3.552 4 3C4 2.448 4.448 2 5 2ZM1 4H2.185C2.599 5.161 3.698 6 5 6C6.302 6 7.401 5.161 7.815 4H19C19.553 4 20 3.553 20 3C20 2.447 19.553 2 19 2H7.815C7.401 0.839 6.302 0 5 0C3.698 0 2.599 0.839 2.185 2H1C0.447 2 0 2.447 0 3C0 3.553 0.447 4 1 4Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTune);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tune.8d43cb1785475ecb49bf26308d17b786.svg";